import { Wifi, Wind, Droplets, Sparkles, Headphones, BellRing } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import content from "@/data/content/amenities.json";

// Map icon names from JSON to lucide components.
const ICONS = { Wifi, Wind, Droplets, Sparkles, Headphones, BellRing };

export const Amenities = () => {
  return (
    <section data-testid="amenities-section" className="bg-ivory">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-2xl">
          <Reveal>
            <span className="text-xs tracking-[0.25em] uppercase text-terracotta font-medium">
              {content.eyebrow}
            </span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-3 font-serif text-3xl md:text-4xl font-semibold text-brown">
              {content.heading}
            </h2>
          </Reveal>
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {content.items.map((a, i) => {
            const Icon = ICONS[a.icon] || Sparkles;
            return (
              <Reveal key={a.label} delay={i * 0.06}>
                <div
                  data-testid={`amenity-${i}`}
                  className="h-full flex flex-col items-center text-center gap-3 rounded-2xl bg-white px-3 py-6 shadow-[0_6px_20px_rgba(74,49,37,0.05)]"
                >
                  <span className="h-11 w-11 rounded-full bg-terracotta/10 flex items-center justify-center">
                    <Icon className="h-5 w-5 text-terracotta" />
                  </span>
                  <span className="text-sm font-medium text-brown leading-snug">{a.label}</span>
                </div>
              </Reveal>
            );
          })}
        </div>

        <p className="mt-5 text-xs text-brown/50 italic">{content.note}</p>
      </div>
    </section>
  );
};

export default Amenities;
